import { css } from "styled-components";
import { vwMobile, vwDesktop } from "../../helpers/styles";
import { MEDIA_DESKTOP } from "../../helpers/theme";

const SectionLines = (color = "#012604") => css`
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    
    background: ${color};
  }

  &::before {
    left: ${vwMobile(17.5)};
  }

  &::after {
    right: ${vwMobile(17.5)};
  }

  ${MEDIA_DESKTOP} {
    &::before {
      left: ${vwDesktop(40)};
    }

    &::after {
      right: ${vwDesktop(40)};
    }
  }
`;
export default SectionLines;
